module.exports = __webpack_public_path__ + "static/media/ic_dustbin_selected_state.38dcc361.svg";